module.exports = __webpack_public_path__ + "img/RocketTravel.d811598b.svg";